import './assets/main.css'
import './assets/fonts/fonts.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { ref } from 'vue'
import { getDatabase, ref as dbRef, onDisconnect, set, onValue } from 'firebase/database'
import { getMessaging, onMessage } from 'firebase/messaging'
import { app as firebaseApp } from './firebase.config'

const connectedUsers = ref<any[]>([])

const setupUserStatus = async (user: any) => {
  if (!user) return

  const database = getDatabase()
  const userStatusRef = dbRef(database, 'status/' + user.uid)
  const connectedRef = dbRef(database, '.info/connected')

  onValue(connectedRef, (snapshot) => {
    if (snapshot.val() === false) return

    set(userStatusRef, {
      online: true,
      lastChanged: Date.now(),
      displayName: user.displayName,
      email: user.email,
      uid: user.uid
    })

    onDisconnect(userStatusRef).update({
      online: false,
      lastChanged: Date.now()
    })
  })

  const allUsersRef = dbRef(database, 'status')
  onValue(allUsersRef, (snapshot) => {
    const data = snapshot.val()
    const onlineUsers: any[] = []

    if (data) {
      Object.entries(data).forEach(([uid, userData]: [string, any]) => {
        if (userData.online) {
          onlineUsers.push(userData)
        }
      })
    }

    connectedUsers.value = onlineUsers
  })
}

const app = createApp(App)

app.use(createPinia())
app.use(router)

// NO MOVER, SOLO PARA PRUEBAS DE DESAROLLO LOCAL ----------------------
if (('serviceWorker' in navigator) && import.meta.env.DEV) { window.addEventListener('load', () => { navigator.serviceWorker.register('/dev-sw.js', { scope: '/' }) }) }
// END NO MOVER, SOLO PARA PRUEBAS DE DESAROLLO LOCAL ----------------------

// Solo manejar mensajes en primer plano si es necesario
const messaging = getMessaging(firebaseApp);
onMessage(messaging, (payload) => {
  console.log('Mensaje en primer plano recibido:', payload);
});

app.mount('#app')

app.provide('connectedUsers', connectedUsers)
app.provide('setupUserStatus', setupUserStatus)
